import CommentList from "./pages/ListPage.vue";
import CommentDetail from "./pages/FormPage.vue";
import CommentIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/comment",
    component: CommentIndex,
    redirect: "/comment/list",
    name: "comment",
    children: [
      {
        path: "list",
        component: CommentList,
        name: "comment.list",
      },
      {
        path: "create",
        component: CommentDetail,
        name: "comment.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CommentDetail,
        name: "comment.edit",
        props: { create: false },
      },
    ],
  },
];
